export const classesLogic = (index, currentStep, previousQuestion) => {
  const classNames = ["step"];
  if (index === currentStep) {
    classNames.push("isCurrent");

    if (previousQuestion < currentStep) {
      classNames.push("anim-will-enter");
    } else if (previousQuestion > currentStep) {
      classNames.push("anim-will-enter-rev");
    }
  } else if (index > currentStep) {
    classNames.push("isNext");

    if (index === previousQuestion) {
      classNames.push("anim-will-leave-rev");
    }
  } else if (index < currentStep) {
    classNames.push("isPrev");
    if (index === previousQuestion) {
      classNames.push("anim-will-leave");
    }
  }

  if (currentStep === 0 && previousQuestion === 0 && index === 0) {
    classNames.push("no-opacity");
  }
  return classNames;
}

export const convertStrToLink = (str, id) => {
  str = str.split('##');

  let newStr = "";
  if (str.length > 1) {
    for (let i = 0; i < str.length; i++) {
      if (i % 2 === 0) {
        newStr += str[i];
      }
      else {
        newStr += `<a class="open-modal" id=${id} >${str[i]}</a>`;
      }
    }
    return newStr;
  }
  else {
    return str;
  }
}

//export default { convertStrToLink, classesLogic };
